import React, { useState } from 'react'
import Datepicker from 'react-datepicker'
import moment from 'moment/moment'
import 'react-datepicker/dist/react-datepicker.css'
import styles from './datepickerSingle.jcss'
import type { DatePickerSingleProps } from './datepickerSingle.types'

export const DatePickerSingle = (p_: DatePickerSingleProps) => {
    const initialDate = moment(p_.value)
    const [dateValue, setDateValue] = useState<Date | null>(initialDate.isValid() ? initialDate.toDate() : null)

    return (
        <div className={styles.datepickerWrapper}>
            <Datepicker
                id={p_.id !== undefined ? String(p_.id) : undefined}
                placeholderText={p_.placeholder}
                selected={dateValue || undefined}
                dateFormat={p_.dateFormat}
                showYearDropdown
                scrollableMonthYearDropdown
                onChange={(date: Date | null) => {
                    setDateValue(date)

                    if (date) {
                        p_.onChange(moment(date).format(p_.onChangeFormat || 'DD-MM-YYYY'))
                    }
                }}
            />
        </div>
    )
}
